import React, { PropsWithChildren } from "react";
import { Grid } from "@material-ui/core";
import { INdaData } from "../../../../../../types/ndaData.interface";
import { UnderNdaBanner } from "../../../../../../features/common-attributes/components/under-nda-banner/under-nda-banner.component";

export interface CbTemplateLayoutProps extends PropsWithChildren<any> {
  ndaData: INdaData;
}

export const CbTemplateLayout = (props: CbTemplateLayoutProps) => (
  <>
    <UnderNdaBanner
      showIf={Boolean(props.ndaData.isUnderNda)}
      underNdaUserDetails={props.ndaData.underNdaUserDetails}
    />
    <Grid container spacing={3}>
      {props.children}
    </Grid>
  </>
);
